export default {
  async start(
    transfer,
    secret,
    recipientId,
    fileEntry = false,
    domain_user_id = false,
    usePopup = false
  ) {
    const form = await transfer.download(
      secret,
      recipientId,
      fileEntry,
      domain_user_id
    );
    if (!form) {
      throw 'DownloadFailed';
    }

    if (usePopup) {
      const link = window.open(form.direct_link);
      if (link) {
        link.opener = null;
      }

      return link;
    }

    return document.location.assign(form.direct_link);
  },
};
